import React from 'react';

import { Empty, Spin } from 'antd';
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';

import IntlMessages from 'util/IntlMessages';

export const renderPieChartContent = ({ data, loading, widgetId, ref }) => {
  if (!data || !data.metrics) {
    return loading ? <Spin size="large" /> : <Empty className="gx-m-auto" description={<IntlMessages id="components.empty.description" />} />;
  }

  const renderLegendText = (value, entry) => {
    const {
      color,
      payload: { value: total },
    } = entry;

    const text = `${value}: ${total}`;
    return <span style={{ color }}>{text}</span>;
  };

  return (
    <>
      {!loading && !!data.metrics?.length && (
        <ResponsiveContainer width="100%" height="100%" minHeight={0} className="cancelDrag">
          <PieChart ref={ref}>
            <Pie dataKey="value" isAnimationActive={false} data={data.metrics} fill="#8884d8">
              {data.metrics.map((metric, index) => (
                <Cell key={`${widgetId}_cell-${index}-${metric.name}`} fill={metric.color} />
              ))}
            </Pie>
            <Tooltip />
            <Legend align="right" layout="horizontal" iconType="plainline" formatter={renderLegendText} />
          </PieChart>
        </ResponsiveContainer>
      )}
      {loading && <Spin size="large" />}
      {!loading && !data.metrics?.length && (
        <Empty className="gx-m-auto" description={<IntlMessages id="components.empty.description" />} />
      )}
    </>
  );
};

